<template>
  <div class="payment-list">
    <div class="payment" v-for="(payment, i) in payments" :key="i">
      <div class="payment-time">{{ payment.time }}</div>
      <div class="payment-type">{{ payment.typeName }}</div>
      <div class="payment-amount">{{ payment.amount }} {{ $store.state.user.currency }}</div>
      <div class="payment-status">{{ payment.statusName }}</div>
      <div
        class="payment-reject"
        @click="rejectPayment(payment.id)"
        v-if="payment.status === 'ordered' && payment.type === 'out'"
      >
        <span v-show="$i18n.locale === 'az'" class="payment-reject-text">ləğv edin</span>
        <span v-show="$i18n.locale === 'ru'" class="payment-reject-text">Отменить</span>
        <span v-show="$i18n.locale === 'en'" class="payment-reject-text">Cancel</span>
      </div>
      <div class="payment-reject-none" v-if="payment.status !== 'ordered' && payment.type !== 'out'"><span class="payment-reject-text-none">Отмена выплаты</span></div>
    </div>
  </div>
</template>

<script>
import AccountService from '@/services/AccountService'
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      payments: state => state.account.payments.data
    })
  },
  data () {
    return {
      success: null
    }
  },
  methods: {
    async rejectPayment (el) {
      const response = await AccountService.rejectPayment({
        paymentOut: el
      })
      console.log(response)
      this.success = response.data.success
      if (this.success) {
        document.location.reload()
      }
    }
  }
}
</script>

<style scoped>
.payment-list { margin: 0 10px; }
.payment-list .payment:not(:first-child) { margin-top: 1px; }
.payment-list .payment:first-child { border-top-left-radius: 5px; border-top-right-radius: 5px; }
.payment-list .payment:last-child { border-bottom-left-radius: 5px; border-bottom-right-radius: 5px; }

.payment { background: rgba(255, 255, 255, .05); display: flex; padding: 10px 15px; text-align: center; }
.payment > div { flex-shrink: 0; }
.payment-time { text-align: left; flex: 1; }
.payment-type { flex: 1; }
.payment-amount { text-align: center; flex: 1; }
.payment-status { text-align: center; flex: 1; }
.payment-reject { background: #ff0; color: #000; border-radius: 3px; line-height: 20px; cursor: pointer; }
.payment-reject-text { margin-left: 4px; margin-right: 4px; font-weight: 500; }
.payment-reject-text-none { margin-left: 4px; margin-right: 4px; font-weight: 500; background: none; color: hsla(0,0%,100%,-0); cursor: default; }
</style>



// WEBPACK FOOTER //
// src/components/account/payments/history/History.vue